"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=e=>({display:"block",mr:"24px",[e.breakpoints.down(e.breakpoints.values.lg)]:{mr:"16px"}});exports.headerLinkPlain=a;
